var baseUrl = "https://portal.youthmath.org/20204";
var tmc_checkout = window.localStorage.getItem("tmc_checkout");
if (tmc_checkout) {
  window.localStorage.removeItem("tmc_checkout");
}
var shopify_locale = Shopify.locale ? Shopify.locale : "en";
var _pendingDeleteId = null;
function isTmcRegister(user, callback) {
  //注册
  wv$.ajax({
    url: baseUrl + "/store/customer/register",
    dataType: "json",
    data: JSON.stringify(user),
    type: "POST",
    contentType: "application/json;charset=UTF-8",
    async: true,
    beforeSend: function () {},
    success: function (res) {
      if (res.statusCode == "404") {
        window.location.href = "/";
        return;
      }
      // localStorage.removeItem("reg_customer");
      callback();
    },
    error: function (res) {},
    complete: function (res) {},
  });
}
function notNull(val) {
  if (val) {
    return val;
  }
  return "";
}
function toUrl(e) {
  var url = wv$(e).attr("uri");
  var id = wv$(e).attr("id");
  var isSchool = localStorage.getItem("is_school");
  if (isSchool && isSchool != null) {
    var attr = isSchool.split("_");
    if (attr[1] != id) {
      localStorage.removeItem("is_school");
    }
  }

  localStorage.setItem("participant_id", id);
  var is_school = wv$(e).attr("is_school");
  var param = is_school + "_" + id;
  localStorage.setItem("is_school", param);
  window.location.href = url;
}
//考试未开始，先弹出提示
function showTipsPop(e) {
  wv$(".tips-pop").fadeIn();
}

var res_url = "https://tmc.youthmath.org?token=";
function statusBtn(item) {
  if (!item.status) {
    item.status = 0;
  }

  switch (item.status) {
    case 0:
      var text =
        shopify_locale == "fr"
          ? `Cliquez pour vous inscrire`
          : shopify_locale == "ja"
          ? `登録するにはクリックしてください`
          : `Click to register`;
      return `<a class="admin-show-info-link" onclick="toUrl(this)" uri="/pages/registration" is_school="individual" id="${item.id}" href="javascript:;">${text}</a>`;
    case 1:
      var text =
        shopify_locale == "fr"
          ? `Soumettre l'inscription`
          : shopify_locale == "ja"
          ? `登録を提出`
          : `Submit Registration`;
      return `<a class="admin-show-info-link" onclick="toUrl(this)" uri="/pages/registration" id="${item.id}" href="javascript:;">${text}</a>`;

    case 2:
      var text =
        shopify_locale == "fr"
          ? `Centre de test`
          : shopify_locale == "ja"
          ? `テストセンター`
          : `Testing Center`;
      if (
        item.registrationNumber == "1255366" ||
        item.registrationNumber == "1233404" ||
        item.registrationNumber == "1274743" ||
        item.registrationNumber == "1238943" ||
        item.registrationNumber == "1270530" ||
        item.registrationNumber == "1261277" ||
        item.registrationNumber == "1258174" ||
        item.registrationNumber == "1248339" ||
        item.registrationNumber == "1208227" ||
        item.registrationNumber == "0455287" ||
        item.registrationNumber == "1241109" ||
        item.registrationNumber == "1253284" ||
        item.registrationNumber == "1212520" ||
        item.registrationNumber == "1213329" ||
        item.registrationNumber == "1217126" ||
        item.registrationNumber == "1296321" ||
        item.registrationNumber == "1273756" ||
        item.registrationNumber == "1211504" ||
        item.registrationNumber == "1209067" ||
        item.registrationNumber == "1210677" ||
        item.registrationNumber == "0194531" ||
        item.registrationNumber == "1298536" ||
        item.registrationNumber == "1225650"
      ) {
        return `<a class="admin-show-info-link authentication-link" target="_blank" href="${res_url}${item.token}"  id="${item.id}">${text}</a>`;
      } else {
        return `<a class="admin-show-info-link authentication-link" target="_blank" href="${res_url}${item.token}"  id="${item.id}">${text}</a> <a class="admin-show-info-link authentication-link" onclick="toUrl(this)" uri="/pages/registration" is_school="individual" id="${item.id}" href="javascript:;">registration</a>`;
        //return `<a class="admin-show-info-link" href="javascript:;" onclick="showTipsPop(this)"  id="${item.id}">${text}</a>`;
      }

    case 3:
      var text =
        shopify_locale == "fr"
          ? `En attente des résultats`
          : shopify_locale == "ja"
          ? `結果待ち`
          : `Waiting for results`;
      return `<a class="admin-show-info-link authentication-link" target="_blank" href="${res_url}${item.token}" id="${item.id}">${text}</a>`;
    case 4:
      var text =
        shopify_locale == "fr"
          ? `Résultats de la requête`
          : shopify_locale == "ja"
          ? `クエリ結果`
          : `Query results`;
      return `<a class="admin-show-info-link authentication-link" target="_blank" href="${res_url}${item.token}" id="${item.id}">${text}</a>`;
    case 5:
      var text =
        shopify_locale == "fr"
          ? `Cliquez pour vous inscrire`
          : shopify_locale == "ja"
          ? `登録するにはクリックしてください`
          : `Click to register`;
      return `<a class="admin-show-info-link" onclick="toUrl(this)" uri="/pages/registration" is_school="individual" id="${item.id}" href="javascript:;">${text}</a>`;
  }
}
function getStatus(item) {
  if (!item.status) {
    item.status = 0;
  }
  switch (item.status) {
    case 0:
      return shopify_locale == "fr"
        ? `Non participé`
        : shopify_locale == "ja"
        ? `参加していません`
        : `Not participated`;
    case 1:
      return shopify_locale == "fr"
        ? `Créé`
        : shopify_locale == "ja"
        ? `作成された`
        : `Created`;

    case 2:
      return shopify_locale == "fr"
        ? `Déjà enregistré`
        : shopify_locale == "ja"
        ? `既に登録済み`
        : `Already registered`;

    case 3:
      return shopify_locale == "fr"
        ? `Testé`
        : shopify_locale == "ja"
        ? `テストされた`
        : `Tested`;
    case 4:
      return shopify_locale == "fr"
        ? `Rempli`
        : shopify_locale == "ja"
        ? `履行された`
        : `Fulfilled`;
  }
}

function deleteRegistration(registrationId) {
  var data = {
    myshopifyDomain: request.myshopifyDomain,
  };
  wv$.ajax({
    url: baseUrl + "/store/customer/registration/delete/" + registrationId,
    dataType: "json",
    data: JSON.stringify(data),
    type: "POST",
    contentType: "application/json;charset=UTF-8",
    async: true,
    beforeSend: function () {
      wv$(".wvloading").show();
    },
    success: function (res) {
      if (res.statusCode == "404") {
        wv$(".wvloading").hide();
        //删除失败
        return;
      }

      window.location.href = "/pages/participants";
    },
    error: function (res) {
      wv$(".wvloading").hide();
    },
    complete: function (res) {},
  });
}
function tmcParticipants(user) {
  //获取考生列表
  wv$.ajax({
    url: baseUrl + "/store/customer/registration/list",
    dataType: "json",
    data: JSON.stringify(user),
    type: "POST",
    contentType: "application/json;charset=UTF-8",
    async: true,
    beforeSend: function () {},
    success: function (res) {
      wv$(".wvloading").hide();
      if (res.statusCode == "404") {
        window.location.href = "/";
        return;
      }
      if (!res.data) {
        window.location.href = "/";
        return;
      }
      if (res.data.registrations && res.data.registrations.length > 0) {
        if (res.data.registrations.length > 3) {
          wv$(".add-participant-btn").hide();
        }
        //有考生
        var html = "";
        for (var i = 0, len = res.data.registrations.length; i < len; i++) {
          var item = res.data.registrations[i];
          var number = "";
          if (item.registrationNumber) {
            number = `<li>ID: ${item.registrationNumber}</li>`;
          }
          var email = "";
          if (item.email) {
            email = `<li>Email: ${item.email}</li>`;
          }
          var grader = "";
          if (item.grader) {
            grader = `<li>Grade: ${item.grader}</li>`;
          }
          var dateOfBirth = "";
          if (item.dateOfBirth) {
            dateOfBirth = `<li>Date of Birth: ${item.dateOfBirth}</li>`;
          }
          var address = "";
          if (item.city || item.states || item.zipcode || item.country) {
            address = `<li>${notNull(item.city)} ${notNull(
              item.states
            )} ${notNull(item.zipcode)} ${notNull(item.country)}</li>`;
          }
          var el = `<div class="admin-show-content" style="position: relative">
                                <div class="participant-op">
                                    <div style="cursor: pointer" class="participant-edit" id="${
                                      item.id
                                    }"><svg class="icon" style="width: 1em;height: 1em;vertical-align: middle;fill: #29A0DE;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4529"><path d="M946.176 896a34.304 34.304 0 0 1 0 68.608H77.824a34.304 34.304 0 0 1 0-68.608h868.352z m0-622.08L401.92 818.176 189.44 839.68l21.504-211.968 473.088-473.088 71.168-71.168c31.744-31.744 87.552-31.744 119.296 0l71.168 71.168c15.872 15.872 24.576 37.376 24.576 59.904 0.512 22.016-8.192 43.52-24.064 59.392zM266.24 762.88l103.936-10.752 431.616-431.616-93.696-93.696L276.48 658.432 266.24 762.88zM815.104 127.488c-4.096 0-8.192 1.536-11.264 4.608l-46.592 46.592 93.696 93.696 46.592-46.592c6.144-6.144 6.144-16.384 0-22.528l-71.168-71.168c-3.072-3.072-7.168-4.608-11.264-4.608z" p-id="4530"></path></svg></div>
                                    <div style="cursor: pointer" class="participant-delete" id="${
                                      item.id
                                    }"><svg class="icon" style="width: 0.5em;height: 0.5em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3392"><path d="M189.124926 206.817739 834.875074 206.817739C824.056355 206.817739 815.037987 197.278738 815.718488 186.375821L766.845228 969.422054C767.420593 960.203599 774.673955 953.37931 784.03501 953.37931L239.96499 953.37931C249.232543 953.37931 256.586205 960.312638 257.154772 969.422054L208.281512 186.375821C208.961624 197.272664 199.982115 206.817739 189.124926 206.817739ZM186.671228 973.821228C188.422497 1001.879852 211.883661 1024 239.96499 1024L784.03501 1024C811.990051 1024 835.582287 1001.80337 837.328772 973.821228L886.202033 190.774996C888.065218 160.922854 864.68894 136.197049 834.875074 136.197049L189.124926 136.197049C159.269853 136.197049 135.939407 160.996952 137.797967 190.774996L186.671228 973.821228ZM971.034483 206.817739C990.535839 206.817739 1006.344828 191.00875 1006.344828 171.507394 1006.344828 152.00602 990.535839 136.197049 971.034483 136.197049L52.965517 136.197049C33.464161 136.197049 17.655172 152.00602 17.655172 171.507394 17.655172 191.00875 33.464161 206.817739 52.965517 206.817739L971.034483 206.817739ZM358.849148 206.817739 665.150852 206.817739C694.015417 206.817739 717.323123 183.246901 717.323123 154.533323L717.323123 52.284416C717.323123 23.465207 693.830144 0 665.150852 0L358.849148 0C329.984583 0 306.676877 23.570838 306.676877 52.284416L306.676877 154.533323C306.676877 183.352514 330.169856 206.817739 358.849148 206.817739ZM377.297567 52.284416C377.297567 62.397193 369.165877 70.62069 358.849148 70.62069L665.150852 70.62069C654.846093 70.62069 646.702433 62.486652 646.702433 52.284416L646.702433 154.533323C646.702433 144.420529 654.834123 136.197049 665.150852 136.197049L358.849148 136.197049C369.153907 136.197049 377.297567 144.331087 377.297567 154.533323L377.297567 52.284416ZM595.6986 835.467988C595.6986 854.969344 611.507571 870.778333 631.008945 870.778333 650.510301 870.778333 666.319289 854.969344 666.319289 835.467988L666.319289 324.729062C666.319289 305.227705 650.510301 289.418717 631.008945 289.418717 611.507571 289.418717 595.6986 305.227705 595.6986 324.729062L595.6986 835.467988ZM428.3014 324.729062C428.3014 305.227705 412.492429 289.418717 392.991055 289.418717 373.489699 289.418717 357.680711 305.227705 357.680711 324.729062L357.680711 835.467988C357.680711 854.969344 373.489699 870.778333 392.991055 870.778333 412.492429 870.778333 428.3014 854.969344 428.3014 835.467988L428.3014 324.729062Z" fill="#389BFF" p-id="3393"></path></svg></div>
                                </div>
                                <div class="admin-show-item">
                                    <img src="//youthmath.org/cdn/shop/files/34_2x_77aaaada-709b-4252-be86-2528d038e4f6.png?v=1719645171">
                                    <div class="admin-show-info">
                                        <div class="admin-show-info-header">${notNull(
                                          item.firstName
                                        )} ${notNull(
            item.middleName
          )} ${notNull(item.lastName)} ${notNull(
            item.fullName
          )}<span class="user-status">${getStatus(item)}</span></div>
                                            <div class="admin-show-info-subheader">
                                                <ul>
                                                    ${number}
                                                   ${email}
                                                   ${grader}
                                                   ${dateOfBirth}
                                                   ${address}
                                                </ul>
                                            </div>
                                            ${statusBtn(item)}
                                          
                                        </div>
                                    </div>
                                </div>`;
          html += el;
        }
        wv$(".participants").html(html);
        /*wv$(".participant-edit").on("click",function () {
                    var id = wv$(this).attr("id");
                    //填写考生表单
                    window.location.href='/pages/add-participant?edit='+id;
                });*/

        wv$(".participant-edit").on("click", function () {
          var customerRegistrationId = wv$(this).attr("id");
          var text =
            shopify_locale == "fr"
              ? `MODIFIER LE PARTICIPANT`
              : shopify_locale == "ja"
              ? `参加者を編集`
              : `EDIT PARTICIPANT`;
          wv$(".regstration-header").text(text);
          //修改 查询数据

          var data = {
            myshopifyDomain: request.myshopifyDomain,
          };
          wv$.ajax({
            url:
              baseUrl +
              "/store/customer/registration/info/" +
              customerRegistrationId,
            dataType: "json",
            data: JSON.stringify(data),
            type: "POST",
            contentType: "application/json;charset=UTF-8",
            async: true,
            beforeSend: function () {
              wv$(".wvloading").show();
            },
            success: function (res) {
              wv$(".wvloading").hide();
              if (res.statusCode == "404") {
                return;
              }
              if (res.data && res.data.registration) {
                var item = res.data.registration;
                wv$("input[name='customerRegistrationId']").val(
                  customerRegistrationId
                );
                // wv$("input[name='firstName']").val(item.firstName);
                // wv$("input[name='lastName']").val(item.lastName);
                wv$("input[name='fullName']").val(item.fullName);
                wv$("#country").val(item.countryId);
                wv$(".wooview-apt-error").text("");
              }

              recordCount();
              wv$(".participant-pop").fadeIn();
            },
            error: function (res) {
              wv$(".wvloading").hide();
            },
            complete: function (res) {},
          });
        });

        wv$(".participant-delete").on("click", function () {
          _pendingDeleteId = wv$(this).attr("id");
          wv$(".participant-del-pop").fadeIn();
        });
      } else {
        isTmcRegister(user, function () {
          localStorage.removeItem("is_school");
          localStorage.removeItem("participant_id");
          //填写考生表单
          window.location.href = "/pages/add-participant";
        });
      }
    },
    error: function (res) {},
    complete: function (res) {},
  });
}

tmcParticipants(request);

//新增修改
var wv = {};
var countryArray = [];
function tmcGetCountry() {
  if (countryArray.length > 0) {
    var country = wv$("#country");
    var others = "";
    for (var i = 0, len = countryArray.length; i < len; i++) {
      if (countryArray[i].name == "Others") {
        others = countryArray[i];
      } else {
        country.append(
          wv$("<option>", {
            text: countryArray[i].name,
            value: countryArray[i].id,
          })
        );
      }
      if (countryArray[i].name == "United States") {
        country.val(countryArray[i].id);
      }
    }
    country.append(wv$("<option>", { text: others.name, value: others.id }));
  }
}
if (countryArray.length === 0) {
  var data = {
    customerId: request.shopifyCustomerId,
    myshopifyDomain: request.myshopifyDomain,
  };
  //获取国家数据
  wv$.ajax({
    url: baseUrl + "/store/customer/regions",
    dataType: "json",
    data: JSON.stringify(data),
    type: "POST",
    contentType: "application/json;charset=UTF-8",
    async: true,
    beforeSend: function () {
      wv$(".wvloading").show();
    },
    success: function (res) {
      wv$(".wvloading").hide();
      if (res.statusCode == "404") {
        return;
      }
      if (res.data && res.data.regions) {
        countryArray = res.data.regions;
        tmcGetCountry();
      }
    },
    error: function (res) {
      wv$(".wvloading").hide();
    },
    complete: function (res) {},
  });
}

function recordCount() {
  var data = {
    customerId: request.shopifyCustomerId,
    myshopifyDomain: request.myshopifyDomain,
  };
  //获取已报名数量
  wv$.ajax({
    url: baseUrl + "/store/customer/registration/recordCount",
    dataType: "json",
    data: JSON.stringify(data),
    type: "POST",
    contentType: "application/json;charset=UTF-8",
    async: true,
    beforeSend: function () {},
    success: function (res) {
      if (res.statusCode == "404") {
        return;
      }
      if (res.data && res.data.recordCount && res.data.recordCount > 0) {
        wv$("#country").val(res.data.countryId);
        wv$("#country").prop("disabled", true);
      } else {
        wv$("#country").prop("disabled", false);
      }
    },
    error: function (res) {},
    complete: function (res) {},
  });
}

// 新增弹窗
wv$(".add-participant-btn").on("click", function () {
  var text =
    shopify_locale == "fr"
      ? `AJOUTER UN PARTICIPANT`
      : shopify_locale == "ja"
      ? `参加者を追加`
      : `ADD PARTICIPANT`;
  wv$(".regstration-header").text(text);
  // wv$("input[name='firstName']").val("");
  // wv$("input[name='lastName']").val("");
  wv$("input[name='fullName']").val("");
  wv$("#country").val("");
  wv$(".wooview-apt-error").text("");
  recordCount();
  wv$(".participant-pop").fadeIn();
});
wv$(".participant-pop-close").on("click", function () {
  wv$(".participant-pop").fadeOut();
});
wv$(".tips-pop-close").on("click", function () {
  wv$(".tips-pop").fadeOut();
});

// 文案长度过滤
wv.lengthFilter = function (str, minLength, maxLength) {
  return (
    wv$.trim(str).length >= minLength &&
    (maxLength ? wv$.trim(str).length <= maxLength : true)
  );
};
wv.validatePhoneNumber = function (phoneNumber) {
  // 正则表达式匹配国际电话号码，例如：+1-202-555-0173
  var regex =
    /^(\+|\d{1,3})\s?(\d{1,4})?\s?\(?\d{1,4}\)?\s?\d{1,4}\s?\-?\d{1,9}$/;
  return regex.test(phoneNumber);
};

// 提交
wv$(".participant-submit").on("click", function () {
  // var firstName = wv$("input[name='firstName']").val();
  // var lastName = wv$("input[name='lastName']").val();
  var fullName = wv$("input[name='fullName']").val();

  var countryId = wv$("#country").val();
  var country = wv$("#country").find("option:selected").text();

  // if(!wv.lengthFilter(firstName,1,50)){
  //     wv$("input[name='firstName']").focus();
  //     wv$(".wooview-apt-error").text("Please enter the first name.");

  //     return;
  // }
  // if(!wv.lengthFilter(lastName,1,50)){
  //     wv$("input[name='lastName']").focus();
  //     wv$(".wooview-apt-error").text("Please enter the last name.");
  //     return;
  // }
  if (!wv.lengthFilter(fullName, 1, 50)) {
    wv$("input[name='firstName']").focus();
    wv$(".wooview-apt-error").text("Please enter the full name.");

    return;
  }

  var data = {
    myshopifyDomain: request.myshopifyDomain,
    shopifyCustomerId: request.shopifyCustomerId,
    // "firstName": firstName,
    // "lastName": lastName,
    fullName: fullName,
    country: country,
    countryId: countryId,
  };
  var customerRegistrationId = wv$(
    "input[name='customerRegistrationId']"
  ).val();
  var url = baseUrl + "/store/customer/registration";
  if (customerRegistrationId) {
    data.id = customerRegistrationId;
    url = baseUrl + "/store/customer/registration/update";
  }
  var _this = wv$(this);
  wv$.ajax({
    url: url,
    dataType: "json",
    data: JSON.stringify(data),
    type: "POST",
    contentType: "application/json;charset=UTF-8",
    async: true,
    beforeSend: function () {
      wv$(".wvloading").show();
      _this.attr("disabled", true);
      _this.addClass("disabledBtn");
      wv$(".wooview-apt-error").text("");
    },
    success: function (res) {
      wv$(".wvloading").hide();
      _this.attr("disabled", false);
      _this.removeClass("disabledBtn");
      if (res.code == "error") {
        wv$(".wooview-apt-error").text(res.message);
      } else {
        window.location.href = "/pages/participants";
      }
    },
    error: function (res) {
      wv$(".wvloading").hide();
      _this.attr("disabled", false);
      _this.removeClass("disabledBtn");
      wv$(".wooview-apt-error").text(res.message);
    },
    complete: function (res) {},
  });
});

function getAuthenticationCustomer() {
  var links = wv$(".authentication-link");
  if (links.length == 0) {
    return false;
  }
  var ids = [];
  for (var i = 0, len = links.length; i < len; i++) {
    var id = wv$(links[i]).attr("id");
    ids.push(id);
  }
  var data = {
    customerId: request.shopifyCustomerId,
    myshopifyDomain: request.myshopifyDomain,
    ids: ids,
  };

  wv$.ajax({
    url: baseUrl + "/store/customer/v/" + data.customerId,
    dataType: "json",
    data: JSON.stringify(data),
    type: "POST",
    contentType: "application/json;charset=UTF-8",
    async: true,
    beforeSend: function () {},
    success: function (res) {
      if (res.statusCode == "404") {
        return;
      }
      if (res.data && res.data.tokens) {
        for (var i = 0, len = links.length; i < len; i++) {
          for (var j = 0, len1 = res.data.tokens.length; j < len1; j++) {
            var item = res.data.tokens[j];
            if (item.id == wv$(links[i]).attr("id")) {
              wv$(links[i]).attr("href", res_url + item.v);
              break;
            }
          }
        }
      }
    },
    error: function (res) {},
    complete: function (res) {},
  });
  return true;
}

var tmc_interval_time = setInterval(function () {
  if (!getAuthenticationCustomer()) {
    clearInterval(tmc_interval_time);
  }
}, 240000);

// 新增点击删除第一个弹窗的确认按钮
wv$(".participant-confirm-one").on("click", function () {
  wv$(".participant-del-pop").fadeOut();
  wv$(".participant-del-pop-two").fadeIn();
});
// 点击删除第一个弹窗的取消按钮
wv$(".participant-cancel-one").on("click", function () {
  wv$(".participant-del-pop").fadeOut();
});

// 点击删除第一个弹窗的关闭按钮
wv$(".participant-del-pop-close").on("click", function () {
  wv$(".participant-del-pop").fadeOut();
});

// 新增点击删除第二个弹窗的确认按钮
wv$(".participant-confirm-two").on("click", function () {
  wv$(".participant-del-pop-two").fadeOut();
  deleteRegistration(_pendingDeleteId);
});
// 点击删除第二个弹窗的取消按钮
wv$(".participant-cancel-two").on("click", function () {
  wv$(".participant-del-pop-two").fadeOut();
});
// 点击删除第一个弹窗的关闭按钮
wv$(".participant-del-two-close").on("click", function () {
  wv$(".participant-del-pop-two").fadeOut();
});